import { Grid, makeStyles } from '@material-ui/core';
import _, { isEmpty } from 'lodash';
import { OnChange } from 'react-final-form-listeners';
import { Trans, useTranslation } from 'react-i18next';
import { 
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { useFormState, useForm } from 'react-final-form';
import { v4 as uuid, validate } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import QCXInfoAlert from '../../shared-components/alert/QCXInfoAlert';
import QCXDynamicFieldGroup from '../../shared-components/dynamic-field-group/QCXDynamicFieldGroup';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectCodigoReceitaAutocomplete from '../../shared-components/final-select-codigo-receita-field/QCXSelectCodigoReceitaAutocomplete';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectBancoAutocompleteField from '../../shared-components/select-banco/QCXSelectBancoAutocompleteField';
import QCXSelectContaBancariaAutocompleteField from '../../shared-components/select-conta-bancaria/QCXSelectContaBancariaAutocompleteField';
import QCXFinalAgenciaTextField from '../../shared-components/text-field-agencia/QCXFinalAgenciaTextField';
import QCXFinalContaCorrenteTextField from '../../shared-components/text-field-conta-corrente/QCXFinalContaCorrenteTextField';
import { PAGAMENTODI } from '../../ts/common/hooks/useHasPermission/permissionsEnum';
import { useHasPermission } from '../../ts/common/hooks/useHasPermission/useHasPermission';
import { normalizeNumeral, unnormalizeNumeral, isStrictEquals } from '../../utils/general/general-utils';
import { isNaoCalculadaStatus } from '../../utils/general/operations/operationUtils';
import { formatBrazilianNumericDecimal } from '../../utils/hooks/form/field/formatters';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFormTitle from '../form-title/QCXFormTitle';
import QCXFinalBondManager from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';
import { selectCodigosReceitas } from '../../features/codigo-receita/codigoReceitaSlice';

const useStyles = makeStyles(() => ({
  gridFields: {
    paddingBottom: '16px',
  },
  fakeFields: {
    height: '40px !important',
    paddingBottom: '16px',
  },
}));

export default function QCXDeclaracaoImportacaoBondManagerPagamentosRetificacao({
  initialValues,
  handleSubmit,
  isConsult,
  controlComponentProps,
  ...restProps
}) {

  const form = useForm();
  const { values } = form.getState();

  const { t } = useTranslation();

  const isAtualizacaoAutoPorcentagemJuros = useRef(false);
  const isAtualizacaoAutoValorJuros = useRef(false);
  const isAtualizacaoAutoPorcentagemMulta = useRef(false);
  const isAtualizacaoAutoValorMulta = useRef(false);

  const [codRet, setCodRet] = useState('');

  const list = useMemo(() => {
    if (!values?.atributosAdicionais?.pagamentos) return []
    if (!_.isArray(values?.atributosAdicionais?.pagamentos)) return []

    const pagamentosDuimp = values?.atributosAdicionais?.pagamentos;

    return pagamentosDuimp

  }, [values]);

  useEffect(() => {
    
    if (!values || !_.get(values, 'atributosAdicionais.processo')) return ;

    const nomeProcesso = _.get(values, 'atributosAdicionais.processo');
    const numeroRet = nomeProcesso.match(/_RET_(\d+)/)[1].padStart(2, '0');;
    
    setCodRet(numeroRet);

  }, [values])


  const codigosReceitaList = useSelector(selectCodigosReceitas);


  const impostosProps = useMemo(() => ({
    name: 'atributosAdicionais.pagamentos',
    columns: [
      {
        field: 'seq',
        headerName: 'Seq.',
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 50,
        valueGetter: ({ row }) => row?.sequencia ? row?.sequencia : "00" , 
      },
      {
        field: 'codigoReceita.code',
        headerName: 'Receita',
        type: 'string',
        flex: 50,
        valueGetter: ({ row }) => row?.codigoReceita?.code,
      },
      {
        field: 'valorReal',
        headerName: 'Valor Total',
        type: 'string',
        flex: 50,
        valueGetter: ({ row }) => row?.valorReal,
      },
      {
        field: 'pago',
        headerName: 'Pago ?',
        type: 'string',
        flex: 20,
        valueGetter: ({ row }) => row?.sequencia !== codRet ? 'Sim' : 'Não',
        renderCell: ({ row }) => {
          const numSequenciaRow = row?.sequencia;
          const isSim = numSequenciaRow !== codRet;
          const tag = isSim ? 'Sim' : 'Não';
        
          const backgroundColor = isSim ? '#F39200' : '#B2B2B2';
          const textColor = '#FFFFFF';
        
          return (
            <div
              style={{
                backgroundColor,
                color: textColor,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                borderRadius: '4px',
              }}
            >
              {tag}
            </div>
          );
        },
      }
    ],
  }), [list]);

  const impostosFormProps = useMemo(() => ({
    rootName: `ignorableFields.tributacao`,
    fields: [
      {
        name: 'codigoReceita.id',
        label: t('com.muralis.qcx.codigoReceita'),
        required: false,
      },
      {
        name: 'valorReal',
        label: 'Valor Original',
        required: false,
      },
      {
        name: 'valorJuros',
        label: 'Valor Juros',
        required: false,
      },
      {
        name: 'porcentagemValorJuros',
        label: 'Juros (%)',
        required: false,
      },
      {
        name: 'valorMulta',
        label: 'Valor Multa',
        required: false,
      },
      {
        name: 'porcentagemValorMulta',
        label: 'Multa (%)',
        required: false,
      },
      {
        name: 'valorTotal',
        label: 'Valor Total',
        required: false,
      },
    ],
  }), [list]);


  const handleAddPagamento = useCallback(async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
    const idCodReceitaSelecionado = _.get(currentVinculo, 'codigoReceita.id');
    const receita = codigosReceitaList.find(el => el.id === idCodReceitaSelecionado);

    if (!receita) return ;

    const vinculo = {
      id: uuid(),
      codigoReceita: {
        ...receita,
      },
      valorReal: currentVinculo.valorTotal,
      isRetificacao: true,
      sequencia: codRet,
    };

    console.log(vinculo)


    handleSuccessAddVinculo([vinculo, ...currentVinculos])
 
  }, [list]);

  const handleUpdatePagamento = useCallback( async (currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {

    const {valorTotal, codigoReceita, ...pagamento} = currentVinculo;
    pagamento.valorMoeda = valorTotal;

    const updatedVinculos = currentVinculos?.map((existingVinculo) => isStrictEquals(existingVinculo?.id, pagamento?.id) ? {
      ...existingVinculo,
      codigoReceita: {...codigoReceita},
      valorReal: valorTotal,
    } : existingVinculo) || currentVinculos;

 
    handleSuccessUpdateVinculo(updatedVinculos);

  }, [list]);

  const handleRemovePagamento = useCallback( async (currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
    form.change(
      'ignorableFields.tributacao', 
      null
    );
  }, [list]);

  const atualizaValorTotal = () => {
    const valorOriginal = parseStringToNum(_.get(values, 'ignorableFields.tributacao.valorReal'));
    const valorMulta    = parseStringToNum(_.get(values, 'ignorableFields.tributacao.valorMulta'));
    const valorJuros    = parseStringToNum(_.get(values, 'ignorableFields.tributacao.valorJuros'));

    const valorTotal = valorOriginal + valorMulta + valorJuros;

    const valorAtualizado = unnormalizeNumeral(valorTotal, formatBrazilianNumericDecimal(2));
    form.change(
      'ignorableFields.tributacao.valorTotal', 
      valorAtualizado
    );

  }

  const valorRealChangeFn = (value, previous) => {
    atualizaValorTotal();
  }


  const parseStringToNum = (numStr) => {
    if (!numStr) return 0;


    const num = parseFloat(
      String(numStr).replace(/\./g, '').replace(',', '.')
    );
    
    if (_.isNaN(num) || num === 0) return 0;

    return num;
  }


  const calculaPorcentagem = (valorStr, totalStr) => {

    const total = parseStringToNum(totalStr);
    const valor = parseStringToNum(valorStr);
    
    if (total === 0 || valor === 0) return 0;
    

    const porcentagem = (valor/total)*100;

    return unnormalizeNumeral(porcentagem, formatBrazilianNumericDecimal(2));

  }

  const calculaPercentual = (porcentagemStr, totalStr) => {

    const porcentagem = parseStringToNum(porcentagemStr);
    const total = parseStringToNum(totalStr);
 
    if (total === 0 || porcentagem === 0) return 0;

    const valor = (total*porcentagem)/100;

    return unnormalizeNumeral(valor, formatBrazilianNumericDecimal(2));

  }


  const valorJurosChangeFn = (value, previous) => {

    if (isAtualizacaoAutoValorJuros.current) {
      isAtualizacaoAutoValorJuros.current = false;
      return ;
    }

    const valorJurosStr = value;
    const valorOriginalStr = _.get(values, 'ignorableFields.tributacao.valorReal');

    const porcentagem = calculaPorcentagem(valorJurosStr, valorOriginalStr);
    
    isAtualizacaoAutoPorcentagemJuros.current = true;

    form.change(
      'ignorableFields.tributacao.porcentagemValorJuros', 
      porcentagem
    );

    atualizaValorTotal();
    
  }

  const porcentagemValorJurosChangeFn = (value, previous) => {
    
    if (isAtualizacaoAutoPorcentagemJuros.current) {
      isAtualizacaoAutoPorcentagemJuros.current = false;
      return ;
    }
  
    const valorPorcentagem = value;
    const valorOriginal = _.get(values, 'ignorableFields.tributacao.valorReal');
    
    const valorPercentual = calculaPercentual(valorPorcentagem, valorOriginal);
    
    isAtualizacaoAutoValorJuros.current = true;
    form.change(
      'ignorableFields.tributacao.valorJuros', 
      valorPercentual
    );

    atualizaValorTotal();

  }

  const valorMultaChangeFn = (value, previous) => {

    if (isAtualizacaoAutoValorMulta.current) {
      isAtualizacaoAutoValorMulta.current = false;
      return ;
    }

    const valorMultaStr = value;
    const valorOriginalStr = _.get(values, 'ignorableFields.tributacao.valorReal');

    const porcentagem = calculaPorcentagem(valorMultaStr, valorOriginalStr);
    
    isAtualizacaoAutoPorcentagemMulta.current = true;

    form.change(
      'ignorableFields.tributacao.porcentagemValorMulta', 
      porcentagem
    );

    atualizaValorTotal();
    
  }

  const porcentagemValorMultaChangeFn = (value, previous) => {
    
    if (isAtualizacaoAutoPorcentagemMulta.current) {
      isAtualizacaoAutoPorcentagemMulta.current = false;
      return ;
    }
  
    const valorPorcentagem = value;
    const valorOriginal = _.get(values, 'ignorableFields.tributacao.valorReal');
    
    const valorPercentual = calculaPercentual(valorPorcentagem, valorOriginal);
    
    isAtualizacaoAutoValorMulta.current = true;
    form.change(
      'ignorableFields.tributacao.valorMulta', 
      valorPercentual
    );

    atualizaValorTotal();

  }

  return (
    <>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12}>
          <QCXFormSubtitle title="IMPOSTOS" />
        </Grid>

        <QCXFinalBondManager
          isParentConsult={isConsult}
          listProps={impostosProps}
          formProps={impostosFormProps}
          handleAdd={handleAddPagamento}
          handleUpdate={handleUpdatePagamento}
          handleRemove={handleRemovePagamento}
          forceShowDelete
        >
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXSelectCodigoReceitaAutocomplete
              id="text-codigo-receita-field-retificacao"
              key="text-codigo-receita-field-retificacao"
              name='ignorableFields.tributacao.codigoReceita.id'
              label={t('com.muralis.qcx.codigoReceita')}
              initialValues={values}
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-field-valor-real"
              key="currency-valor-field-valor-real"
              name='ignorableFields.tributacao.valorReal'
              label='Valor Original'
              scale={2}
              adorned
              disabled={isConsult}
            />

            <OnChange name='ignorableFields.tributacao.valorReal'>
                {(value, previous) => valorRealChangeFn(value, previous)}
            </OnChange>
          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-field-valor-juros"
              key="currency-valor-field-valor-juros"
              name='ignorableFields.tributacao.valorJuros'
              label='Valor Juros'
              scale={2}
              adorned
              disabled={isConsult}
            />

            <OnChange name='ignorableFields.tributacao.valorJuros'>
                {(value, previous) => valorJurosChangeFn(value, previous)}
            </OnChange>
          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-field-porcentagem-juros"
              key="currency-valor-field-porcentagem-juros"
              name='ignorableFields.tributacao.porcentagemValorJuros'
              label='Juros (%)'
              scale={2}
              disabled={isConsult}
            />

            <OnChange name='ignorableFields.tributacao.porcentagemValorJuros'>
                {(value, previous) => porcentagemValorJurosChangeFn(value, previous)}
            </OnChange>

          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-field-valor-multa"
              key="currency-valor-field-valor-multa"
              name='ignorableFields.tributacao.valorMulta'
              label='Valor Multa'
              scale={2}
              adorned
              disabled={isConsult}
            />

            <OnChange name='ignorableFields.tributacao.valorMulta'>
                {(value, previous) => valorMultaChangeFn(value, previous)}
            </OnChange>

          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-field-porcentagem-multa"
              key="currency-valor-field-porcentagem-multa"
              name='ignorableFields.tributacao.porcentagemValorMulta'
              label='Multa (%)'
              scale={2}
              disabled={isConsult}
            />

            <OnChange name='ignorableFields.tributacao.porcentagemValorMulta'>
                {(value, previous) => porcentagemValorMultaChangeFn(value, previous)}
            </OnChange>
          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-field-total"
              key="currency-valor-field-total"
              name='ignorableFields.tributacao.valorTotal'
              label='Valor Total'
              scale={2}
              adorned
              disabled={isConsult}
            />
          </Grid>
        </QCXFinalBondManager>
      </Grid>
    </>

  );
}
